import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur många frågor har kunskapsprovet?";
const SHORT_ANSWER = "60 frågor vid stadigvarande till allmänheten, 44 vid tillfälligt till allmänheten, 28 vid stadigvarande/tillfälligt till slutet sällskap.";

export const Route = createFileRoute("/fraga/hur-manga-fragor-har-provet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur många frågor har kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Frågeantal regleras i FoHMFS 2014:7 bilaga 1. Frågorna fördelas över ett antal kunskapsområden och du behöver normalt klara minst 75% rätt per område (inte bara totalt)."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/hur-manga-ratt-kunskapsprovet", label: "Hur många rätt krävs – komplett guide" }}
      related={[{"to": "/fraga/hur-manga-ratt-kravs", "label": "Hur många rätt krävs på kunskapsprovet?"}, {"to": "/fraga/hur-lang-tid-tar-provet", "label": "Hur lång tid har jag på mig på kunskapsprovet?"}, {"to": "/fraga/vad-ar-kunskapsprovet", "label": "Vad är kunskapsprovet i alkohollagen?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur många frågor har kunskapsprovet?" },
      { name: "description", content: "60 frågor vid stadigvarande till allmänheten, 44 vid tillfälligt till allmänheten, 28 vid stadigvarande/tillfälligt till slutet sällskap." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-manga-fragor-har-provet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-manga-fragor-har-provet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-manga-fragor-har-provet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur många frågor har kunskapsprovet", url: "https://alkoholprovet.se/fraga/hur-manga-fragor-har-provet" },
      ]),
    ],
  }),
});
